import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-brand-blue text-warm-white border-t border-brand-blue-hover">
      <div className="mx-auto max-w-7xl px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 lg:gap-16">
          {/* Column 1: Brand & CVR */}
          <div className="space-y-4">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-brand-orange text-warm-white">
                <i className="fa-solid fa-store text-lg" />
              </div>
              <span className="font-display text-xl font-bold tracking-wide">
                Havneloppen
              </span>
            </div>
            <p className="text-sm text-warm-white/70 max-w-sm leading-relaxed">
              Dit hyggelige, lokale loppemarked i Nyborg. Vi har altid spændende retro fund, teaktræsmøbler, porcelæn, lamper, malerier og designklassikere på hylderne.
            </p>
            <div className="text-xs text-warm-white/50">
              CVR-nummer: <span className="font-mono">42145866</span>
            </div>
          </div>

          {/* Column 2: Opening Hours */}
          <div className="space-y-4">
            <h3 className="font-display text-lg font-semibold text-brand-orange">
              Åbningstider
            </h3>
            <ul className="space-y-2.5 text-sm text-warm-white/85">
              <li className="flex justify-between border-b border-warm-white/10 pb-1.5">
                <span>Mandag - Torsdag:</span>
                <span className="font-mono font-medium">10:00 - 18:00</span>
              </li>
              <li className="flex justify-between border-b border-warm-white/10 pb-1.5 text-warm-white/40">
                <span>Fredag:</span>
                <span className="font-medium">Lukket</span>
              </li>
              <li className="flex justify-between border-b border-warm-white/10 pb-1.5">
                <span>Lørdag - Søndag og helligdage:</span>
                <span className="font-mono font-medium">10:00 - 16:00</span>
              </li>
            </ul>
          </div>

          {/* Column 3: Contact & Socials */}
          <div className="space-y-4">
            <h3 className="font-display text-lg font-semibold text-brand-orange">
              Kontakt butikken
            </h3>
            <ul className="space-y-3 text-sm text-warm-white/85">
              <li className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-brand-orange mt-1" />
                <span>Knudshovedvej 38, 5800 Nyborg</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-brand-orange" />
                <a href="tel:+4528767915" className="hover:text-brand-orange transition-colors whitespace-nowrap">
                  28 76 79 15
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-brand-orange" />
                <a href="mailto:havneloppen@gmail.com" className="hover:text-brand-orange transition-colors whitespace-nowrap">
                  havneloppen@gmail.com
                </a>
              </li>
            </ul>

            <div className="pt-2">
              <a
                href="https://www.facebook.com/p/Havneloppen-100063561880040/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-md bg-brand-orange px-4 py-2 text-sm font-semibold text-warm-white hover:bg-brand-orange-hover transition-colors"
              >
                <i className="fa-brands fa-facebook text-base" />
                Følg os på Facebook
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 border-t border-warm-white/10 pt-8 text-center text-xs text-warm-white/40">
          <p>© {new Date().getFullYear()} Havneloppen. Alle rettigheder forbeholdes. Designet med lokal kærlighed i Nyborg.</p>
        </div>
      </div>
    </footer>
  );
}
